module.exports = __webpack_public_path__ + "img/exhibition-img3.d510fc44.png";